import { authenticatedFetch } from '../utils/apiInterceptor';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const paymentService = {
  // Initiate payment with PayU
  async initiatePayment(planName, brandId, token) {
    try {
      const response = await authenticatedFetch(`${API_BASE_URL}/api/payments/initiate/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          pricing_plan_name: planName,
          brand_id: brandId
        }),
      });

      return await response.json();
    } catch (error) {
      console.error('Payment initiation error:', error);
      throw error;
    }
  },

  // Check payment status
  async getPaymentStatus(transactionId, token) {
    try {
      const response = await authenticatedFetch(`${API_BASE_URL}/api/payments/status/${transactionId}/`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      return await response.json();
    } catch (error) {
      console.error('Payment status check error:', error);
      throw error;
    }
  },

  // Submit form to PayU gateway
  submitToPayU(paymentData, paymentUrl) {
    if (!paymentUrl || !paymentData || typeof paymentData !== 'object') {
      console.error('Invalid payment data or URL provided');
      return;
    }

    // Create a form dynamically and submit to PayU
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = paymentUrl;
    form.style.display = 'none';

    // Add all payment data as hidden inputs
    Object.keys(paymentData).forEach(key => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = paymentData[key];
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  }
};
